"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _dateHelpers = require("../../../utils/date-helpers");
var _helpers = require("../../../utils/helpers");
var _AirDateFormatter = _interopRequireDefault(require("../../utils/AirDateFormatter"));
function AirDateSegment(_ref) {
  let {
    scheduleItem,
    styles
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([styles['schedule-list__airdate'], 'schedule-list__airdate'])
  }, (0, _dateHelpers.determineIfShowIsOnNow)("".concat(scheduleItem.start_date, " ").concat((0, _helpers.convert12to24)(scheduleItem.start_time)), scheduleItem.element_length) && /*#__PURE__*/_react.default.createElement("div", {
    className: "schedule-list__on-now"
  }, "On Now"), /*#__PURE__*/_react.default.createElement(_AirDateFormatter.default, {
    airdateStr: "".concat(scheduleItem.start_date, " ").concat((0, _helpers.convert12to24)(scheduleItem.start_time)),
    separatorType: "line-break"
  }));
}
var _default = exports.default = AirDateSegment;